/** @file A session's own batches: the live store's while it is current, those left at stop afterwards. */
import { liveStore, type PendingBatch } from '../../stores/liveStore';
import { liveSession, type SyncSession } from './liveSession';

/** Batches `session` still owns (empty once a stopped session has drained). */
export function sessionBatches(session: SyncSession): readonly PendingBatch[] {
  return liveSession.get() === session ? liveStore.getState().batches : (session.afterStop ?? []);
}
